import React from 'react'
import { CSVLink } from 'react-csv'
import { chunkArrayInGroups } from 'srcReact/helpers/utils'
import { convertUTCToTimezone } from 'srcReact/helpers/datetimeHelper'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { isWorkplaceManager } from 'srcReact/helpers/workplaceHelper'

export default function getThreeDotsOptions(
  mixr,
  t,
  isNative,
  setActiveTab,
  setShowAddToCalendarPopup,
  setCancelMixrPopup,
  isMobile,
  isStaffMember,
  isOrganizer,
  isGoing,
  participants,
  customCSVStyle,
  setIsSuspendModalOpen,
  handleAddToCalendar
) {
  let options = []
  if (mixr && mixr.status !== 'over' && mixr.status !== 'cancelled') {
    if (isStaffMember) {
      if (mixr && mixr.group && mixr.group.id > 0) {
        options.push({ text: t('mixrHome.moreOptions.editMixr'), href: `/0/${mixr.group.id}/edit-mixr/${mixr.id}` })
      }
    }
    if (isMobile) {
      options.push({ text: t('mixrHome.invite'), href: `/0/event/${mixr.id}/invite-members` })
    }
    if (isGoing) {
      options.push({
        text: t('mixrHome.moreOptions.addToCalendar'),
        onClick: () => {
          handleAddToCalendar()
          // setShowAddToCalendarPopup(true)
        }
      })
    }
    if (isStaffMember) {
      options.push({
        text: t('mixrHome.moreOptions.manageParticipants'),
        onClick: () => {
          setActiveTab(1)
        }
      })
    }
  }
  if (mixr && mixr.group && mixr.group.id > 0) {
    options.push({ text: t('mixrHome.moreOptions.planMixr'), href: `/0/${mixr.group.id}/create-mixr` })
  } else {
    options.push({ text: t('mixrHome.moreOptions.planMixr'), href: `/0/create-mixr` })
  }
  if (mixr && mixr.status !== 'over' && isOrganizer) {
    options.push({ text: t('mixrHome.moreOptions.cancelMixr'), onClick: () => setCancelMixrPopup(true) })
  }
  if (!isNative && mixr && mixr.status !== 'over' && isStaffMember) {
    let newParticipants = []
    participants.map((m, i) =>
      newParticipants.push(m.firstname, m.lastname, m.email, t(`myhome.mymixrs.attendingType.${m.attending_type}`))
    )
    options.push({
      text: (
        <CSVLink
          filename={`${mixr && mixr.name}.csv`}
          className={customCSVStyle}
          data={[
            [mixr?.name],
            [
              mixr?.location?.timezone &&
                `${convertUTCToTimezone(
                  mixr.utc_start_at || mixr.local_start_at,
                  mixr.location.timezone.UTCOffset || mixr.location.timezone.utc_offset,
                  appConstantSettings.DATE_FORMAT8
                )}`
            ],
            [mixr && mixr.location && mixr.location.name],
            [
              t('mixrHome.moreOptions.downloadList.firstname'),
              t('mixrHome.moreOptions.downloadList.lastname'),
              t('mixrHome.moreOptions.downloadList.email'),
              t('mixrHome.moreOptions.downloadList.going')
            ],
            ...chunkArrayInGroups(newParticipants, 4)
          ]}>
          {t('mixrHome.moreOptions.downloadList.button')}
        </CSVLink>
      )
    })
  }
  if (!isStaffMember && isWorkplaceManager()) {
    //1206158840299382-If the group or mixr is created by one of workplace managers himself, display option "suspend" only for Organization admin
    //Do not display this option for workplace managers
    if (
      mixr?.organizer?.is_workplace_manager === 0 ||
      (mixr?.organizer?.is_workplace_manager === 1 && mixr.logged_user?.is_organization_admin === 1)
    ) {
      options.push({
        text: t('moderationReport.flagPost.suspend'),
        onClick: () => setIsSuspendModalOpen(true)
      })
    }
  }
  return options
}
